import {
  CFPaymentGateway,
  type CFPaymentResult,
} from "capacitor-plugin-cashfree-pg";
import type { NativeCashfreeCheckoutInput } from "./cashfree-payment.types";

const BRAND_PRIMARY = "#B87F2C";
const BRAND_ON_PRIMARY = "#FFFFFF";

export async function startNativeCashfreeCheckout(
  input: NativeCashfreeCheckoutInput,
): Promise<CFPaymentResult> {
  return CFPaymentGateway.doWebCheckoutPayment({
    session: {
      payment_session_id: input.paymentSessionId,
      orderID: input.orderId,
      environment: input.paymentEnvironment,
    },
    theme: {
      navigationBarBackgroundColor: BRAND_PRIMARY,
      navigationBarTextColor: BRAND_ON_PRIMARY,
    },
  } as unknown as Parameters<typeof CFPaymentGateway.doWebCheckoutPayment>[0]);
}
